/**
 * Created by mathias.gamperl on 01.02.2016.
 */

// Not working, but maybe we just dont need it
// import "modernizr"

// Seems to be just for IE 6-8
//import "respond"


import "jquery";
import "bootstrap";

//import "moment";
///import "./assets/javascripts/diners/vendor/masonry.pkgd.min.js"

//import "bower_components/respond/dest/respond.min.js";
//import "./assets/javascripts/diners/vendor/select2.min.js";
//import "bower_components/angular-bootstrap/ui-bootstrap-tpls.min.js";
//import "bower_components/angular-smart-table/dist/smart-table.js";
//import "bower_components/matchmedia-ng/matchmedia-ng.js";
//import "bower_components/angular-messages/angular-messages.js";
//import "bower_components/angular-toastr/dist/angular-toastr.min.js";
//import "bower_components/angular-ui-select/dist/select.js";
//import "bower_components/angular-validation-match/dist/angular-input-match.min.js";
//import "bower_components/Chart.js/Chart.min.js";
//import "bower_components/angular-chart.js/dist/angular-chart.js";
//import "bower_components/angular-loading-bar/build/loading-bar.min.js";
//import "bower_components/ngScrollTo/ng-scrollto.js";
//import "./assets/javascripts/diners/plugins/ui-charts.js";



// WEBPACK FOOTER //
// ./src/ui/vendor.js